import React, { useState, useEffect } from 'react';
import '../styles/QuranPageImage.css';
import QuranAPI from '../services/quranAPI';

const QuranPageImage = ({ pageNumber, pageUrl }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [imageSource, setImageSource] = useState(pageUrl);

  // Fallback to alternative URLs if needed
  useEffect(() => {
    if (pageUrl) {
      setImageSource(pageUrl);
    } else if (pageNumber) {
      // Si l'URL n'est pas fournie mais que nous avons le numéro de page
      const url = QuranAPI.getQuranPageImage(pageNumber);
      setImageSource(url);
    }
  }, [pageNumber, pageUrl]);
  
  if (!pageNumber || !imageSource) {
    return null;
  }

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    console.error(`Erreur de chargement d'image pour la page ${pageNumber}`);
    
    // Essayer de charger l'image de secours
    if (imageSource !== '/quran-placeholder.png') {
      console.log('Tentative de chargement de l\'image de secours');
      setImageSource('/quran-placeholder.png');
    } else {
      // Si l'image de secours ne se charge pas non plus
      setIsLoading(false);
      setError(true);
    }
  };

  return (
    <div className="quran-page-container">
      <div className="quran-page-header">
        <h3>Page {pageNumber} du Mushaf</h3>
      </div>
      
      <div className="quran-page-content">
        {isLoading && <div className="loading-spinner"></div>}
        
        {error ? (
          <div className="image-error">
            <p>Impossible de charger l'image de la page {pageNumber}.</p>
          </div>
        ) : (
          <img 
            src={imageSource}
            alt={`Page ${pageNumber} du Coran`}
            className={`quran-page-image ${isLoading ? 'hidden' : ''}`}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        )}
      </div>
      
      <div className="quran-page-footer">
        <p>Source: King Fahd Quran Complex</p>
      </div>
    </div>
  );
};

export default QuranPageImage;
